export default "__VITE_ASSET__60268ec6__"